// biome-ignore-all lint/plugin/no-unlabeled-form-inputs: legacy unlabeled inputs, burn-down tracked in HTUI-392
import { FC, useEffect, useRef, useState } from "react";
import { Button, TextInput, Box, Textarea } from "@hightouch/htui";

type Props = {
  isDisabled?: boolean;
  isHidden?: boolean;
  isInvalid?: boolean;
  multiline?: boolean;
  placeholder?: string;
  value: string;
  onChange(value: string | null): void;
};

export const SecretInput: FC<Readonly<Props>> = ({
  onChange,
  value,
  multiline,
  isHidden,
  isDisabled,
  isInvalid,
  placeholder,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const container = useRef<HTMLDivElement>(null);

  const maskValue = isHidden && !isEditing;
  const displayValue = maskValue ? "•".repeat(12) : (value ?? "");

  const disabled = isDisabled || maskValue;

  useEffect(() => {
    if (isEditing) {
      const inputElement = container.current?.querySelector(
        "textarea, input",
      ) as HTMLElement | undefined;
      inputElement?.focus();
    }
  }, [isEditing]);

  return (
    <Box ref={container} display="flex" gap={3}>
      {multiline ? (
        <Textarea
          isDisabled={disabled}
          isInvalid={isInvalid}
          resize="vertical"
          placeholder={placeholder}
          value={displayValue}
          onChange={(event) => {
            onChange(event.currentTarget.value);
          }}
        />
      ) : (
        <TextInput
          isDisabled={disabled}
          isInvalid={isInvalid}
          type="password"
          placeholder={placeholder}
          value={displayValue}
          onChange={(event) => onChange(event.currentTarget.value)}
        />
      )}

      {isHidden && !isDisabled && (
        <Box
          alignItems="center"
          display="flex"
          flex="none"
          opacity={isEditing ? 0 : 1}
          pointerEvents={isEditing ? "none" : undefined}
        >
          <Button
            onClick={() => {
              if (multiline) {
                onChange("");
              } else {
                onChange(null);
              }
              setIsEditing(true);
            }}
          >
            Edit
          </Button>
        </Box>
      )}
    </Box>
  );
};
